import React from 'react';
import EnhancedStepper from '@components/stepper/EnhancedStepper';
import { makeStyles } from 'tss-react/mui';
import { MAIN_THEME } from '@styles';
import StepperActions from './StepperActions';
import { IAmendmentPageData } from '../..';
import { IAmendmentGeneralData } from '../../line-amendment';
import ShowForUser from '@components/common/ShowForUser';
import FormattingService from '@services/FormattingService';

interface IStepper {
  generalData: IAmendmentGeneralData;
  values: IAmendmentPageData;
  onSuccess: () => void;
}

const useStyles = makeStyles()(() => ({
  stepperContainer: {
    margin: '20px 0',
    display: 'grid',
    gridTemplateColumns: '2fr 1fr',
    gap: '1em',
    alignItems: 'start',
  },
  stepper: {
    backgroundColor: 'transparent',
    width: '95%',
    marginBottom: '20px',
    '& .MuiStepLabel-root .Mui-active, .MuiStepLabel-root .Mui-completed': {
      color: MAIN_THEME.color.black,
    },

    '@media only screen and (min-width: 600px)': {
      maxWidth: '1300px',
    },
  },
}));

const Stepper: React.FC<IStepper> = ({ generalData, values, onSuccess }) => {
  const { classes } = useStyles();

  const amendmentActiveOrNew =
    generalData.amendment.status === 'NEW' ||
    generalData.amendment.status === 'IN_PROGRESS';

  const steps = ['NEW', 'IN_PROGRESS', 'COMPLETED'];
  if (!steps.includes(generalData.amendment.status)) {
    steps.pop();
    steps.push(generalData.amendment.status);
  }

  return (
    <section className={classes.stepperContainer}>
      <EnhancedStepper
        activeStep={FormattingService.formatEnumToDisplay(
          generalData.amendment.status ?? steps[0]
        )}
        steps={steps.map((step) => FormattingService.formatEnumToDisplay(step))}
        className={classes.stepper}
      />
      {amendmentActiveOrNew && (
        <ShowForUser
          allowedRoles={['Core-BusinessUser']}
          allowedAgentTypes={['']}
        >
          <StepperActions
            generalData={generalData}
            values={values}
            onSuccess={onSuccess}
          />
        </ShowForUser>
      )}
    </section>
  );
};

export default Stepper;
